import { mapWorldTourFormat } from "./FsWorldTourFormat";
import { WorldTourSet } from "model/Match/Set/WorldTour/WorldTourSet";
import { mapWorldTourTracks } from "./FsWorldTourTrack";
import { MatchTeams } from "model/Match/MatchTeams";
import { Scores } from "model/Scores";
import { FsWorldTourSet } from "db/model/match/Set/WorldTour/FsWorldTourSet";
import {
  calculateIsCompletePlayCondition,
  calculateTrackPointBasedSetScores,
  mapMatchSetBase,
} from "../FsMatchSet";
import { calculateFinalPositions } from "model/Positions";
import { getDefinedRosterIds } from "model/Roster/Roster";

export const mapWorldTourSet = (
  fsModel: FsWorldTourSet,
  teams: MatchTeams
): WorldTourSet | undefined => {
  if (!fsModel.format) {
    return undefined;
  }

  const format = mapWorldTourFormat(fsModel.format);
  if (!format) {
    return undefined;
  }

  const tracks = mapWorldTourTracks(
    fsModel.tracks ?? [],
    teams.rosters,
    teams.scope,
    format.scoring,
    format.trackWinReq,
    format.driversPerTeam
  );

  const scores = calculateTrackPointBasedSetScores(
    tracks,
    fsModel.scoreOverrides,
    getDefinedRosterIds(teams.rosters)
  );

  const numCompleteTracks = tracks.filter((t) => t.isComplete).length;
  const isComplete = calculateIsCompletePlayCondition(
    scores,
    format.numTracks,
    numCompleteTracks,
    format.playCondition
  );

  const finalPositions = calculateFinalPositions(
    isComplete,
    scores,
    compareScores
  );

  return {
    ...mapMatchSetBase(fsModel, isComplete, finalPositions, scores),
    format,
    tracks,
    type: "WorldTour",
  };
};

// todo - Add tiebreaker logic here
const compareScores = (scores: Scores, a: string, b: string) => {
  return scores[b] - scores[a];
};
